import { ACTIVE, ADD_CHAIN_PARAMS } from '../config/networks';

// Returns true if the wallet is already on the correct chain.
export function isCorrectChain(chainId) {
  if (chainId == null) return false;
  const id = typeof chainId === 'string' ? parseInt(chainId, 16) : Number(chainId);
  return id === ACTIVE.chainId;
}

// Silently switch the wallet to the active network.
// If the chain is unknown to the wallet, it adds it first.
// IMPORTANT: this NEVER calls window.location.reload() — no refresh.
export async function switchToActiveNetwork(ethereum) {
  if (!ethereum) throw new Error('No wallet found.');

  try {
    await ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: ACTIVE.chainIdHex }],
    });
    return true;
  } catch (err) {
    // 4902 = chain not added to wallet. Trust Wallet sometimes uses -32603.
    const code = err && (err.code || (err.data && err.data.originalError && err.data.originalError.code));
    if (code === 4902 || code === -32603) {
      try {
        await ethereum.request({
          method: 'wallet_addEthereumChain',
          params: [ADD_CHAIN_PARAMS],
        });
        // After adding, try the switch once more.
        await ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: ACTIVE.chainIdHex }],
        });
        return true;
      } catch (addErr) {
        throw addErr;
      }
    }
    throw err;
  }
}
